// extracted by mini-css-extract-plugin
module.exports = {"faq-groups":"b_b","faqGroups":"b_b","faq-group":"b_c","faqGroup":"b_c","group-title":"b_d","groupTitle":"b_d","tour-accordion-item":"b_f","tourAccordionItem":"b_f"};